module.exports = __webpack_public_path__ + "img/ancient_pyramid_small.ad6d5f17.png";